// Croqui: `components/Mono.tsx`.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { INK_TEXT, type Ink } from './ink.ts';

/** Tamanhos que o croqui usa em `Mono` (10 · 11 · 12 · 13 · 14). */
const SIZE = {
  10: 'text-10',
  11: 'text-11',
  12: 'text-12',
  13: 'text-13',
  14: 'text-14',
} as const;

export type MonoSize = keyof typeof SIZE;

/**
 * Texto monoespaçado: ids, rotas, chaves, campos da API (`spec/17` §4.6).
 * `break-all` é regra de 390px (`spec/24` §4 item 6): id longo quebra, não empurra a tela.
 */
export function Mono({
  children,
  size = 12,
  ink = 'faint',
  className,
}: {
  children: ReactNode;
  size?: MonoSize;
  ink?: Ink;
  className?: string;
}) {
  return (
    <span className={cn('break-all font-mono', SIZE[size], INK_TEXT[ink], className)}>
      {children}
    </span>
  );
}
